// export const BASE_URL =
//   "https://portalized.dev.bootlegstudios.com/portalizedApis/";

//PRODUCTION
export const BASE_URL = "https://app.portalized.com/api/";

//DEV
// export const BASE_URL = "http://192.168.18.35/portalizedApis/";

// https://portalized.dev.bootlegstudios.com/portalizedApis/
// 'http://192.168.18.24/portalizedApis/';
// export const BASE_URL =
//   'https://portalized.dev.bootlegstudios.com/portalizedApis/';

//portalized.dev.bootlegstudios.com/portalizedApis/
// export const BASE_IMAGE = 'http://192.168.18.24/';
